"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var SimpleTextInputWithValidation = _react.default.createClass({
  displayName: "SimpleTextInputWithValidation",
  propTypes: {
    ariaLabel: _react.PropTypes.string,
    className: _react.PropTypes.string,
    description: _react.PropTypes.node,
    disabled: _react.PropTypes.bool,
    required: _react.PropTypes.bool,
    id: _react.PropTypes.string,
    inline: _react.PropTypes.bool,
    invalidMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
    isInvalid: _react.PropTypes.bool,
    label: _react.PropTypes.node,
    labelTooltip: _react.PropTypes.node,
    disabledTooltip: _react.PropTypes.node,
    onBlur: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    placeholder: _react.PropTypes.string,
    value: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      required: true
    };
  },
  render: function render() {
    var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        className = _this$props.className,
        description = _this$props.description,
        disabled = _this$props.disabled,
        id = _this$props.id,
        inline = _this$props.inline,
        invalidMessage = _this$props.invalidMessage,
        isInvalid = _this$props.isInvalid,
        label = _this$props.label,
        labelTooltip = _this$props.labelTooltip,
        onBlur = _this$props.onBlur,
        onChange = _this$props.onChange,
        placeholder = _this$props.placeholder,
        required = _this$props.required,
        value = _this$props.value,
        disabledTooltip = _this$props.disabledTooltip;
    var invalidClass = isInvalid ? 'leadin-text-input__text--invalid' : '';
    var inlineClass = inline ? 'private-form__control--inline' : '';
    var inputClasses = disabled ? invalidClass : invalidClass + " " + inlineClass;
    var disabledClass = disabled ? 'input-disabled' : '';
    var formControlClasses = className + " " + disabledClass;

    var textInput = _react.default.createElement(_UIFormControl.default, {
      className: formControlClasses,
      error: isInvalid,
      validationMessage: invalidMessage,
      label: label,
      "aria-label": ariaLabel,
      tooltip: labelTooltip,
      description: description,
      required: !inline && required
    }, _react.default.createElement(_UITextInput.default, {
      className: inputClasses,
      disabled: disabled,
      id: id,
      onBlur: onBlur,
      onChange: onChange,
      placeholder: placeholder,
      value: value
    }));

    return Boolean(disabled && disabledTooltip) ? _react.default.createElement(_UITooltip.default, {
      title: disabledTooltip
    }, textInput) : textInput;
  }
});

var _default = SimpleTextInputWithValidation;
exports.default = _default;
module.exports = exports.default;